<template lang="pug">

    .field.left.icon(:class='{ required: isRequired }')
        label(v-if='label') {{ label }}
        .ui.left.icon.error.input
            input(type='text' v-bind:value='viewValue' v-bind:disabled='disabled' readonly)
            i.clock.icon
        slot


</template>

<script>
    import TimePicker from "appointment-picker"

    //noinspection ReservedWordAsName
    export default {

        computed: {

            viewValue() {
                const hours = String(this.value.hours).padStart(2, "0")
                const minutes = String(this.value.minutes).padStart(2, "0")
                return `${hours}:${minutes}`
            }

        },

        mounted() {
            new TimePicker(this.$el.querySelector('input'), {
                interval: 30,
                minTime: 10,
                maxTime: 20,
                startTime: 10,
                endTime: 20,
                title: undefined,
            })

            document.addEventListener('change.appo.picker', ({ time }) => {
                this.$emit("input", { hours: time.h, minutes: time.m })
            })
        },

        props: {

            value: {
                required: true
            },

            label: {
                type: String,
            },

            isRequired: {
                type: Boolean,
                default: false
            },

            disabled: {
                type: Boolean,
                default: false
            },

        }

    }

</script>

<!--suppress CssUnusedSymbol -->
<style>
    @import "~appointment-picker/css/appointment-picker.css";

    .appo-picker-title {
        display: none;
    }
</style>
